<template>
  <SalesPlayDrawerCard>
    <div class="drawer-sectionLabel">FILTER MODE</div>
    <label class="drawer-toggleField">
      <ToggleSwitch :model-value="excluding" @update:model-value="onChange" />
      <span class="drawer-toggleLabel">{{ excluding ? 'Exclude' : 'Keep' }}</span>
    </label>
  </SalesPlayDrawerCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ToggleSwitch from '../../../components/ToggleSwitch.vue'
import SalesPlayDrawerCard from './SalesPlayDrawerCard.vue'
import { useSalesPlayDraft } from '../../composables/useSalesPlayDraft'

const props = defineProps<{
  playId: string
  pipelineId: string | null
  nodeIndex: number
}>()

const { nodes, updateNodeConfig } = useSalesPlayDraft()

const excluding = computed(() => nodes.value[props.nodeIndex]?.config?.mode === 'drop_matching')

function onChange(next: boolean) {
  updateNodeConfig(props.nodeIndex, { mode: next ? 'drop_matching' : 'keep_matching' })
}
</script>
